import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';

class Education extends Component {
    render() {
        return (
            <Grid className="timeline-row">
                <Cell col={4} tablet={4} phone={12} className="timeline-date">
                    <p>
                        {this.props.startYear} - {this.props.endYear}
                    </p>
                </Cell>
                <Cell col={8} tablet={8} phone={12} className="timeline-detail">
                    <h5 className="timeline-title">{this.props.schoolName}</h5>
                    <p>{this.props.schoolDescription}</p>
                </Cell>
            </Grid>
        );
    }
}

export default Education;
